import React, { useEffect, useState, useRef } from "react";

import { Header } from "./ProjectsLayout/index";
import { useProjectsList } from "../../contexts/ProjectsListContext";
import { CLink } from "../../components/_reusables";

const Footer = () => {
	const { projectSectRef } = useProjectsList();

	const [tranVal, setTranVal] = useState(50);

	useEffect(() => {
		const handle = () => {
			let elemRect =
				projectSectRef.current &&
				projectSectRef.current.getBoundingClientRect();

			const winHeight = window.innerHeight;
			const elemBottom = elemRect.bottom;

			const header = document.querySelector(".page-header");

			if (elemBottom <= winHeight && elemBottom > 0) {
				const transVal =
					(-51 * (winHeight - elemBottom) - winHeight * -51) /
					-winHeight;

				setTranVal(transVal);

				header.classList.add("disappear");
			} else {
				setTranVal(0);

				header.classList.remove("disappear");
			}

			if (elemBottom < 0) {
				header.classList.add("disappear");
			}
		};

		document.addEventListener("scroll", handle);

		return () => document.removeEventListener("scroll", handle);
	});

	const [animateStats, setAnimateStats] = useState("");

	return (
		<footer
			className="footer wf-section"
			style={{ transform: `translate(0px, ${tranVal}%)` }}
			id="contact-me"
		>
			<div className="standard_container footer-container w-container">
				{/* <div className="footer-nav"></div> */}
				<Header />

				<div className="footer-flex">
					<div className="w-layout-grid footer-grid">
						<div id="w-node-_02f68737-207c-1098-31c7-5f0bba6f5fc3-cf09c80d">
							<p
								id="w-node-c8896f15-913e-f2bd-f255-0769b3b1036a-cf09c80d"
								className="h20 h20-footer "
								style={{
									lineHeight: 1.3,
									fontWeight: "500 !important",
								}}
							>
								Hi, I'm Timi Odulate, 'TheCopyDev'.
								<span
									style={{
										display: "block",
										height: ".4rem",
									}}
								/>
								I'm a fullstack software developer With over 4
								years of experience, I excel in building
								websites, web applications, and mobile apps,
								prioritizing both speed and quality.
								<span
									style={{
										display: "block",
										height: ".4rem",
									}}
								/>
								Available for hire—let's collaborate and bring
								your ideas to life!
								{/* Hi, Im Timi Odulate 'TheCopyDev.
								<br />
								An experienced software developer with a passion
								for crafting seamless and top-notch digital
								solutions.
								<br />
								With over 4 years of expertise building
								websites, website applications, and mobile
								applications, I thrive on versatility, embracing
								any technology required to deliver exceptional
								results.
								<br />
								My commitment to speed without compromising
								quality of the user interface and user
								experience of every project I work on ensures
								that projects are delivered on time.
								<br />I am available for hire.
								<br />
								LET’S WORK — TOGETHER */}
							</p>
							<CLink
								id="w-node-_4c5a1afd-01c7-dbcc-c6df-03be846b807b-cf09c80d"
								href="https://wa.me/+9038995326"
								external
								className="btn cta-footer-contact w-inline-block"
							>
								<div
									className="btn-outer"
									onMouseEnter={() =>
										setAnimateStats("animate-start")
									}
									onMouseLeave={() =>
										setAnimateStats("animate-end")
									}
								>
									<div
										className={`btn-mask btn-bottom ${animateStats}`}
									>
										<div className="btn-text">
											GET&nbsp;IN&nbsp;TOUCH
										</div>
									</div>
									<div
										className={`btn-mask btn-top ${animateStats}`}
									>
										<div className="btn-text">Hire me</div>
									</div>
								</div>
							</CLink>
						</div>

						<div
							id="w-node-_8e2d7881-7867-d9ab-17ee-80ac96e05fca-cf09c80d"
							className="div-block-55 "
						>
							<div className="div-block-56">
								<h2 className="hsmallest grey contact-email">
									Business inquiries
								</h2>
								<ul>
									<li>
										<CLink
											href="mailto:timiodulate@gmail.com"
											className="link hsmall"
											external
										>
											{/* hello@dashdigital.io */}
											timiodulate@gmail.com
										</CLink>
									</li>
									<li>
										<a
											href="tel:+2349038995326"
											className="link hsmall"
										>
											+234 9038995326
										</a>
									</li>
								</ul>
							</div>
							{/* <div className="div-block-57">
								<div id="w-node-cf2e06d1-ba42-355e-c3b9-0d0787cf9f3a-cf09c80d">
									<h2 className="hsmallest grey footer-contact">
										Hire me for :
									</h2>
									<div className="w-dyn-list">
										<ul role="list" className="w-dyn-items">
											<li className="listitem w-dyn-item">
												<p className="link hsmall roles">
													Website Development
												</p>
											</li>
											<li className="listitem w-dyn-item">
												<p className="link hsmall roles">
													UI/UX Design
												</p>
											</li>
											<li className="listitem w-dyn-item">
												<p className="link hsmall roles">
													Frontend Development
												</p>
											</li>
											<li className="listitem w-dyn-item">
												<p className="link hsmall roles">
													Backend Development
												</p>
											</li>
											<li className="listitem w-dyn-item">
												<p className="link hsmall roles w-condition-invisible">
													Mobile App Development
												</p>
											</li>
										</ul>
									</div>
								</div>
							</div> */}
						</div>
					</div>
				</div>

				<div className="w-layout-grid footer-meta footer-footer">
					<div
						id="w-node-f8c4b24f-62fe-1f12-3714-f9026c957a7a-cf09c80d"
						className="copyright-wrap"
					>
						<p className="hsmallest copyright">THECOPYDEV ©2022</p>
					</div>
					<ul
						id="w-node-_796c08d5-ae47-50e8-c3a5-9d42579148c5-cf09c80d"
						className="footer-links"
					>
						<li
							id="w-node-_7e64fa94-6cdf-ecc0-ab2f-fdb8914ccb21-cf09c80d"
							className="footer-link"
						>
							<CLink
								href="https://github.com/timiodulate"
								external
								className="link hsmallest"
							>
								Github
							</CLink>
						</li>
						<li
							id="w-node-_7e64fa94-6cdf-ecc0-ab2f-fdb8914ccb21-cf09c80d"
							className="footer-link"
						>
							<CLink
								href="https://www.linkedin.com/in/timiodulate/"
								external
								className="link hsmallest"
							>
								Linkedin
							</CLink>
						</li>

						<li
							id="w-node-_63cc78d3-1720-7e5a-75d2-4046f2c91226-cf09c80d"
							className="footer-link"
						>
							<CLink
								href="https://twitter.com/timiodulate/"
								external
								className="link hsmallest"
							>
								Twitter
							</CLink>
						</li>
					</ul>
					<a
						id="w-node-_73e090b0-9b7f-bf0e-2111-67dc3aeaa89a-cf09c80d"
						href="#"
						className="link hsmallest btt"
					>
						BACK&nbsp;TO&nbsp;TOP
					</a>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
